import "./OptionLabel.less";

export function OptionLabel({ active, label }: { active: boolean; label: string }) {
  return (
    <span className="theme-option">
      <span className={`theme-option__dot${active ? " theme-option__dot--active" : ""}`} />
      <span className={`theme-option__label${active ? " theme-option__label--active" : ""}`}>{label}</span>
    </span>
  );
}
